import CryptoJS from 'crypto-js'
import { useGlobalStore } from '@haohan/clw-store'
import { getShareOrigin, getShareToken } from './shareAuth'

const TokenKey = 'ClW-Token'
const ThemeKey = 'ClW-theme'
const IsAutoKey = 'ClW-Auto'

export function getToken(): string {
  // return Cookies.get(TokenKey) as string
  const token = getWithExpiry(TokenKey)
  // 更新过期时间
  if (token !== null) {
    setWithExpiry(TokenKey, token.value, token.ttl)
  } else {
    return token
  }
  // 如登录等，不适合这个
  // else {
  //   // 取不到Token，则刷新浏览器
  //   location.reload()
  // }
  return token.value
}

export function setToken(token: string, isAuto = false) {
  // console.log('[ token ]-10', token)
  if (isAuto) {
    // return Cookies.set(TokenKey, token, { expires: 100 }) 604800000
    // 设置100天过期时间
    return setWithExpiry(TokenKey, token, 604800000)
  }
  // 设置半小时过期时间
  return setWithExpiry(TokenKey, token)
  // return Cookies.set(TokenKey, token)
}

export function removeToken() {
  // return Cookies.remove(TokenKey)
  localStorage.removeItem(TokenKey)
}
/**
 * 云视域平台对接portal时默认登录 portal用户
 */
export function setClwPortalToken() {
  console.log('portal 登录')
  // 登录用户为portal
  return setWithExpiry(TokenKey, '')
}
/**
 * 云视域项目对接portal时默认登录admin用户
 */
export function setProjectPortalToken() {
  console.log('portal 登录')
  // 登录用户为admin
  return setWithExpiry(TokenKey, '')
}

export function getTheme() {
  // return Cookies.get(ThemeKey)
  return localStorage.getItem(ThemeKey)
}

export function setTheme(theme?: string) {
  if (theme) {
    localStorage.setItem(ThemeKey, theme)
  }
  // theme && localStorage.setItem(ThemeKey, theme)
}
export function removeTheme() {
  localStorage.removeItem(ThemeKey)
}

// 设置数据并指定过期时间（以毫秒为单位），1800000 半小时
function setWithExpiry(key: string, value: string, ttl = 1800000) {
  // 如果为私有化部署，则默认过期时间为100天
  const now = new Date().getTime()
  const item = {
    value: value, // 实际存储的数据
    expiry: now + ttl, // 过期时间 = 当前时间 + ttl（毫秒）
    ttl
  }
  localStorage.setItem(key, JSON.stringify(item))
  return value
}

// 获取数据并检查是否过期
function getWithExpiry(key: string) {
  const itemStr = localStorage.getItem(key)
  // 如果数据不存在，返回 null
  if (!itemStr) {
    return null
  }

  const item = JSON.parse(itemStr)
  const now = new Date().getTime()

  // 如果数据已过期，删除数据并返回 null
  if (now > item.expiry) {
    localStorage.removeItem(key)
    return null
  }

  // 返回未过期的数据
  return item
}
/**
 * 获得md5加密后的token
 * @returns md5加密token
 */
export function getMd5Token() {
  const isShareOrigin = getShareOrigin()
  let token = ''
  // 分享登录
  if (location.href.includes('?shareId=') && isShareOrigin) {
    token = getShareToken()
  } else {
    // 平台
    token = getToken()
  }
  const sToken = JSON.parse(localStorage.getItem('Share-Token') || '{}')
  if (!token) {
    return token
  }
  const tokenInfo = {
    token: token,
    timestamp: isShareOrigin ? sToken?.expiry : new Date().getTime()
  }
  // console.log('getMd5Token', tokenInfo, JSON.stringify(tokenInfo))
  return {
    ...tokenInfo,
    sign: CryptoJS.MD5(JSON.stringify(tokenInfo)).toString()
  }
}

export function getTokenHeaderInfo() {
  const tokenInfo = getMd5Token()
  if (tokenInfo) {
    return {
      authorization: tokenInfo.token,
      timestamp: tokenInfo.timestamp,
      sign: tokenInfo.sign
    }
  }
  return {
    authorization: undefined,
    timestamp: undefined,
    sign: undefined
  }
}

export function getHeaderInfoByToken(token: string) {
  const tokenInfo = {
    token: token,
    timestamp: new Date().getTime()
  }
  return {
    timestamp: tokenInfo.timestamp,
    authorization: token,
    sign: CryptoJS.MD5(JSON.stringify(tokenInfo)).toString()
  }
}
